
import _withFocusable2 from './withFocusable.js';

import _spatialNavigation2 from './spatialNavigation.js';

export const withFocusable = _withFocusable2;
export const initNavigation = _spatialNavigation2.init;
export const setKeyMap = _spatialNavigation2.setKeyMap;
export const hasFocusedChild = _spatialNavigation2.hasFocusedChild;
/* Local addition: is `focusKey` registered and focusable right now (live,
   unlike anything derived from props). Lets a caller target a known
   container only when it exists, instead of focusing a dead key. */
export const isFocusableRegistered = _spatialNavigation2.isParticipatingFocusableComponent;
